module.exports = __webpack_public_path__ + "static/bidwaan-2aa1cf5f02cfc95b11121bf0ea17e879.png";